var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-row',[_c('b-button',{attrs:{"size":"sm","to":'/forms/injuryreportform/' + _vm.item.id}},[_vm._v("View Form")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }